export const MS_PER_DAY = 86_400_000
